
export default function Contact() {
  return (
    <section id="contact" className="py-20 bg-gradient-to-br from-[#f8f9f8] to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-[#444c42] mb-4">
            Book Your Free Consultation
          </h2>
          <p className="text-lg text-[#7A8178] max-w-2xl mx-auto leading-relaxed">
            Take the first step toward stress-free dental care. Click the button below to book your free consultation.
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          {/* CTA Button */}
          <div className="text-center mb-16">
            <a
              href="https://beaulieudental.co.uk/book-free-consultation/"
              target="_blank"
              rel="noopener noreferrer"
              className="group inline-flex items-center gap-2 bg-gradient-to-r from-[#d0a24f] to-[#dcb964] text-white px-10 py-5 rounded-full font-semibold text-xl hover:shadow-2xl hover:scale-105 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-calendar-check-line text-2xl"></i>
              Book Your Free Consultation
              <i className="ri-arrow-right-line text-2xl group-hover:translate-x-1 transition-transform"></i>
            </a>
          </div>

          {/* Contact Information */}
          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-white rounded-3xl shadow-xl p-8">
              <h3 className="text-2xl font-bold text-[#444c42] mb-6">Get In Touch</h3>
              
              <div className="space-y-6">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 rounded-full bg-gradient-to-br from-[#d0a24f] to-[#dcb964] flex items-center justify-center flex-shrink-0">
                    <i className="ri-phone-line text-white text-xl"></i>
                  </div>
                  <div>
                    <div className="font-semibold text-[#444c42] mb-1">Phone</div>
                    <a href="tel:01245465586" className="text-[#7A8178] hover:text-[#d0a24f] transition-colors cursor-pointer">
                      01245 465586
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 rounded-full bg-gradient-to-br from-[#d0a24f] to-[#dcb964] flex items-center justify-center flex-shrink-0">
                    <i className="ri-whatsapp-line text-white text-xl"></i>
                  </div>
                  <div>
                    <div className="font-semibold text-[#444c42] mb-1">WhatsApp</div>
                    <a href="https://wa.me/447426343948" target="_blank" rel="noopener noreferrer" className="text-[#7A8178] hover:text-[#d0a24f] transition-colors cursor-pointer">
                      07426 343948
                    </a>
                    <p className="text-xs text-[#7A8178] mt-1">
                      Available from 7:00 AM to 9:00 PM
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 rounded-full bg-gradient-to-br from-[#d0a24f] to-[#dcb964] flex items-center justify-center flex-shrink-0">
                    <i className="ri-mail-line text-white text-xl"></i>
                  </div>
                  <div>
                    <div className="font-semibold text-[#444c42] mb-1">Email</div>
                    <a href="mailto:appointments@beaulieudental.co.uk" className="text-[#7A8178] hover:text-[#d0a24f] transition-colors cursor-pointer break-all">
                      appointments@beaulieudental.co.uk
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 rounded-full bg-gradient-to-br from-[#d0a24f] to-[#dcb964] flex items-center justify-center flex-shrink-0">
                    <i className="ri-map-pin-line text-white text-xl"></i>
                  </div>
                  <div>
                    <div className="font-semibold text-[#444c42] mb-1">Address</div>
                    <p className="text-[#7A8178]">
                      Beaulieu Dental<br />
                      11 Centenary Way<br />
                      Beaulieu Square, Springfield<br />
                      Chelmsford CM1 6AU
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Visit Main Website */}
            <div className="bg-gradient-to-br from-[#d0a24f] to-[#dcb964] rounded-3xl shadow-xl p-8 text-white">
              <div className="flex items-center gap-3 mb-4">
                <i className="ri-global-line text-4xl"></i>
                <h3 className="text-2xl font-bold">Visit Our Main Website</h3>
              </div>
              <p className="text-white/95 text-base mb-6 leading-relaxed">
                Explore Our Full Range of Services
              </p>
              <p className="text-white/90 text-sm mb-6 leading-relaxed">
                Discover all our dental treatments, meet our team, and learn more about Beaulieu Dental.
              </p>
              <a
                href="https://www.beaulieudental.co.uk"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 bg-white text-[#d0a24f] px-6 py-3 rounded-full font-semibold text-base hover:bg-white/95 hover:scale-105 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-external-link-line text-lg"></i>
                Visit Beaulieu Dental
                <i className="ri-arrow-right-line text-lg"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}